import CMSData from "./cms-data"

/**
 * Get a text bundle from the CMS and return the content
 * @param {*} param0
 */
const TextBundle = ({ id }) => {
  const { data } = CMSData({
    contentType: "TextBundle",
    match: { "content.id": id },
  })
  const raw = data[0]?.data
  // `data` may be stored either as an object map ({ key: value }) or as a
  // key/value list ([{ key, value }]). Consumers read texts?.key, so normalize
  // the list form to a map; the map form passes through unchanged.
  if (Array.isArray(raw)) {
    return raw.reduce((acc, item) => {
      if (item && item.key != null) acc[item.key] = item.value
      return acc
    }, {})
  }
  return raw
}

export default TextBundle
